import React, { useEffect, useState } from "react";
import RecursiveTxns from "../Recursive/RecursiveTxns";
import OneTimeTxn from "./OneTimeTxn";

function NewTxn() {
  const [txnType, setTxnType] = useState("onetime");

  useEffect(() => {
    
  }, []);

  return (
          <div className="d-flex flex-column bg-white mb-5">
            <div className="btn-group w-100 py-3" role="group">
              <button
                type="button"
                className="btn btn-app btn-block"
                onClick={(e) => setTxnType("onetime")}
              >
                One Time
              </button>
              <button
                type="button"
                className="btn btn-outline-app btn-block"
                onClick={(e) => setTxnType("recurring")}
              >
                Recurring
              </button>
            </div>
            <OneTimeTxn />
            {/* {txnType === "onetime" ? <OneTimeTxn /> : <RecursiveTxns /> } */}
          </div>
      // <div className="row">
      //   {(LOCATION_PATHNAME === "/cashbook" && status.type === "success") ? (
      //   <div className="position-fixed w-auto" style={{ zIndex: 2, top: "60%", left: "50%",transform:"translateX(-50%)" }}>
      //     <div className="rounded-circle position-relative" style={{width:"100px",height:"100px", backgroundColor:"#32CD32", boxShadow: "0 1rem 3rem #000" }}>
      //       <i className="bi bi-check2 text-white position-absolute" style={{ fontSize: "50px", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}></i>
      //     </div>
      //   </div>
      // ) : (
      //   status.type === "success" && (
      //   <div className="status-center" style={{top:"30%"}}>
      //     <div className="rounded-circle position-relative" style={{width:"100px",height:"100px", backgroundColor:"#32CD32", boxShadow: "0 1rem 40px #000" }}>
      //       <i className="bi bi-check2 text-white position-absolute" style={{ fontSize: "50px", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}></i>
      //     </div>
      //   </div>
      //   )
      // )}
      // </div>
  );
}
export default NewTxn;